export type SignalsOverlayLevelKey = 'entryInitial' | 'entryMid' | 'entryFinal' | 'stop' | 'targets'

export type SignalsOverlayLevels = {
  entryInitial: boolean
  entryMid: boolean
  entryFinal: boolean
  stop: boolean
  targets: boolean
}

const DEFAULTS: SignalsOverlayLevels = {
  entryInitial: true,
  entryMid: true,
  entryFinal: true,
  stop: true,
  targets: true,
}

export function defaultSignalsOverlayLevels(): SignalsOverlayLevels {
  return { ...DEFAULTS }
}

